import { render, staticRenderFns } from "./ChooseHouse.vue?vue&type=template&id=1a4d7399&scoped=true"
import script from "./ChooseHouse.vue?vue&type=script&lang=js"
export * from "./ChooseHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d7399",
  null
  
)

export default component.exports